<template>
  <span
    v-for="(segment, index) in segments"
    :key="index"
    :class="[
      'search-select-highlight__segment',
      segment.isMatch ? 'search-select-highlight__segment--match' : '',
    ]"
  >
    {{ segment.text }}
  </span>
</template>

<script setup>
defineProps({
  segments: {
    type: Array,
    required: true,
  },
})
</script>

<style lang="scss" scoped>
.search-select-highlight {
  &__segment {
    white-space: pre-wrap;

    &--match {
      text-decoration: underline;
      text-underline-offset: 2px;
      color: inherit;
    }
  }
}
</style>
